




































































































































import { Component, Vue } from "vue-property-decorator";
import FilterLaporanKebidanan from "@/components/laporan-kebidanan/FilterLaporanKebidanan.vue";
import TabelRegisterKebidanan from "@/components/laporan-kebidanan/TabelRegisterKebidanan.vue";
import OverlayProsesBerkas from "@/components/laporan-kebidanan/OverlayProsesBerkas.vue";
import LaporanKebidananSvc, {
  BarisRegisterKebidanan,
  FilterKebidanan,
  KolomRegisterKebidanan,
  OpsiUnitKebidanan,
  RegisterGinekologiResponse,
  filterAwal,
  filterSiap
} from "@/services/LaporanKebidanan";

let tokenMuat = 0;

@Component({
  components: {
    FilterLaporanKebidanan,
    TabelRegisterKebidanan,
    OverlayProsesBerkas
  }
})
export default class LaporanRegisterGinekologiPage extends Vue {
  filter: FilterKebidanan = filterAwal();
  filterTampil: FilterKebidanan | null = null;
  data: RegisterGinekologiResponse | null = null;
  opsiUnit: OpsiUnitKebidanan[] = [];
  loading = false;
  mencetak = false;
  mengunduh = false;
  page = 1;
  perPage = 50;
  readonly perPageOpts = [25, 50, 100];

  get kolom(): KolomRegisterKebidanan[] {
    return this.data ? this.data.kolom : [];
  }

  get rows(): BarisRegisterKebidanan[] {
    return this.data ? this.data.rows : [];
  }

  get ringkasanRuang(): { id: string; nama: string; jumlah: number }[] {
    if (!this.data) return [];

    const perRuang = this.data.meta.per_ruang || {};

    return this.opsiUnit
      .filter(u => perRuang[u.id])
      .map(u => ({ id: u.id, nama: u.nama, jumlah: perRuang[u.id] }));
  }

  get alasanPdfMati(): string {
    if (!this.data) return "";

    const total = this.data.meta.total;
    const maks = this.data.params.max_pdf_baris;

    if (!total) return "";

    if (total > maks) {
      return `Cetak PDF maksimal ${maks} pasien, sedangkan hasil saat ini ${total} pasien. Persempit periode atau ruang, atau gunakan Unduh Excel.`;
    }

    return "";
  }

  get judulProses(): string {
    const jenis = this.mencetak ? "PDF" : "Excel";
    const total = this.data ? this.data.meta.total : 0;

    return `Menyiapkan ${jenis} Register Ginekologi (${total} pasien)`;
  }

  get nomorAwal(): number {
    return this.data ? (this.data.meta.page - 1) * this.data.meta.per_page + 1 : 0;
  }

  get nomorAkhir(): number {
    return this.data ? this.nomorAwal + this.data.rows.length - 1 : 0;
  }

  mounted(): void {
    this.muat(1);
  }

  async muat(page: number): Promise<void> {
    if (!filterSiap(this.filter)) return;

    const token = ++tokenMuat;
    const filter: FilterKebidanan = { ...this.filter, unit: this.filter.unit.slice() };
    this.loading = true;

    try {
      const res = await LaporanKebidananSvc.registerGinekologi(filter, page, this.perPage);

      if (token !== tokenMuat) return;

      this.data = res;
      this.page = res.meta.page;
      this.filterTampil = filter;
      this.opsiUnit = res.params.opsi_unit;
    } catch {
      return;
    } finally {
      if (token === tokenMuat) this.loading = false;
    }
  }

  async cetakPdf(): Promise<void> {
    if (!this.filterTampil || this.alasanPdfMati) return;

    this.mencetak = true;

    try {
      await LaporanKebidananSvc.pdfRegisterGinekologi(this.filterTampil);
    } catch {
      return;
    } finally {
      this.mencetak = false;
    }
  }

  async unduhExcel(): Promise<void> {
    if (!this.filterTampil) return;

    this.mengunduh = true;

    try {
      await LaporanKebidananSvc.excelRegisterGinekologi(this.filterTampil);
    } catch {
      return;
    } finally {
      this.mengunduh = false;
    }
  }
}
